import type { SortKey, SortState } from '@/lib/findingSort';

export function SortableTh({
  label,
  sortKey,
  sort,
  onSort,
  align = 'left',
}: {
  label: string;
  sortKey: SortKey;
  sort: SortState | null;
  onSort: (key: SortKey) => void;
  align?: 'left' | 'right';
}) {
  const active = sort?.key === sortKey;
  const arrow = active ? (sort.dir === 'desc' ? '↓' : '↑') : '↕';
  return (
    <th className={`px-3 py-2 font-medium ${align === 'right' ? 'text-right' : 'text-left'}`}>
      <button
        type="button"
        onClick={() => onSort(sortKey)}
        className={`inline-flex items-center gap-1 transition-colors hover:text-brand-navy ${
          active ? 'text-brand-navy' : ''
        }`}
        aria-label={`Sort by ${label}`}
      >
        {label}
        <span className={`text-[10px] ${active ? '' : 'text-brand-slate/50'}`}>{arrow}</span>
      </button>
    </th>
  );
}
